// extracted by mini-css-extract-plugin
export var active = "_6i-7";
export var container = "_6i-0";
export var evenWidth = "_6i-4";
export var large = "_6i-5";
export var outlet = "_6i-8";
export var slide = "_6i-2";
export var small = "_6i-6";
export var tab = "_6i-3";
export var tabs = "_6i-1";